import { render, staticRenderFns } from "./CmgLeaveRewardsModal.vue?vue&type=template&id=5efa23da&scoped=true&lang=pug&"
import script from "./cmg-leave-rewards-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-leave-rewards-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLeaveRewardsModal.vue?vue&type=style&index=0&id=5efa23da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa23da",
  null
  
)

export default component.exports